// extracted by mini-css-extract-plugin
export default {"mainContainer":"styles_mainContainer__ppi5E","inputBox":"styles_inputBox__vtsmf"};